module.exports = __webpack_public_path__ + "images/cancer.b4003f14890eb59a11cc91b883a323d5.svg";